/**
 * The penalty notices read (NT-132): the IRS penalty notices recorded on a federal-tax order, each
 * with its relief request. Recording a notice and building the letter are operator actions; the
 * console's two writes are in `federal-tax-writes.ts`. Split out of `catalog.ts` on file-size grounds
 * only. It sits below `:orderId`, like `/packets`, so `upstream-siblings.ts` needs no row.
 */
import type { ReadRoute } from "./catalog";

export const PENALTY_NOTICES_READ_ROUTES: readonly ReadRoute[] = [
  { path: "/api/admin/federal-tax/:orderId/penalty-notices", query: [] },
];
